import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PlaybookGrid } from "@/pages/Landing";

export default function Playbooks() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/playbooks").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-6xl mx-auto px-6 pt-16" data-testid="playbooks-page">
      <p className="eyebrow mb-4">Use Cases</p>
      <h1 className="font-serif-d text-5xl sm:text-6xl tracking-tight mb-6 rise">Choose the lens.</h1>
      <p className="text-lg text-[var(--ink-2)] max-w-2xl mb-14">Each use case is a fixed checklist written for one kind of document. We suggest one automatically, and you can always pick another.</p>
      <PlaybookGrid items={items} />
    </div>
  );
}
